<template>
  <div id="app2" ref="app2" :class="iscCross ? 'cross' : ''">
    <a-config-provider :locale="locale">
      <router-view />
    </a-config-provider>
  </div>
</template>
<script>
import zhCN from "ant-design-vue/es/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
dayjs.locale("zh-cn");
import { menuQueryList } from "@/api/api";
import { getToken, setMenuList, getMenuList } from "@/utils/auth";
export default {
  data() {
    return {
      locale: zhCN,
      iscCross: false,
    };
  },
  mounted() {
    if (document.documentElement.clientWidth < 450) {
      this.iscCross = true;
      document.getElementById("app").style.overflow = 'none'
    } else {
      this.iscCross = false;
      document.getElementById("app").style.overflow = 'hidden'
    }
    window.onresize = function () {
      if (document.documentElement.clientWidth < 450) {
        this.iscCross = true;
      } else {
        this.iscCross = false;
      }
    };
    
    // 如果已登录，获取菜单数据
    this.fetchMenuData();
  },
  watch: {
    // 监听路由变化，如果已登录则获取菜单（每次刷新都获取最新菜单）
    '$route': {
      handler(to) {
        // 如果不在登录页，且已登录，则获取菜单（强制刷新）
        if (to.path !== '/login') {
          const token = getToken();
          if (token) {
            this.fetchMenuData();
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    // 获取菜单数据
    async fetchMenuData() {
      // 检查是否有 token，如果有则获取菜单
      const token = getToken();
      if (token) {
        try {
          // 过滤菜单数据（递归过滤 type=0 的目录项，但保留其子节点）
          const filterMenuByType = (menus) => {
            const result = [];
            menus.forEach(menu => {
              if (menu.type === 0) {
                // type=0 目录本身不保留，但将其子节点提升到当前层级
                if (menu.children && menu.children.length > 0) {
                  result.push(...filterMenuByType(menu.children));
                }
              } else {
                const item = { ...menu };
                if (item.children && item.children.length > 0) {
                  item.children = filterMenuByType(item.children);
                }
                result.push(item);
              }
            });
            return result;
          };

          const menuRes = await menuQueryList({});
          if (menuRes.code === "200" && menuRes.data) {
            // 过滤掉 type=0 的菜单项后再保存
            const filteredMenuData = filterMenuByType(menuRes.data);
            setMenuList(filteredMenuData);
          }
        } catch (error) {
          console.error("获取菜单数据失败:", error);
        }
      }
    }
  },
};
</script>
<style>
#app {
  height: 100%;
  /* overflow: hidden; */
  /* min-width: 600px; */
}
.cross {
  /* width: 100vh;
  height: 100%;
  transform: rotate(90deg);
  transform-origin: 50vw 50vw;
  overflow: auto;
  padding-bottom: 80vw; */
}
</style>
